function toggleActivePurchaseOption(container = document) {
  const radioButtons = container.querySelectorAll('input:is([name="purchaseOption"], [name="quick-buy-purchaseOption"])');
  const inputSellingPlan = container.querySelector('input[name="selling_plan"]');

  const selectedSubscriptionFrequency = container.querySelector('.yk-custom-select');
  const dispatchSellingPlanChange = (planType) => {
    const eventName = container.closest?.('#fast-buy-drawer')
      ? 'quick-buy:selling-plan-change'
      : 'onSellingPlanChange';
    document.dispatchEvent(
      new CustomEvent(eventName, {
        detail: {
          planType,
          container,
        },
      })
    );
  };

  radioButtons.forEach((radio) => {
    radio.addEventListener('change', function () {
      container.querySelectorAll('.custom-widget-wrapper').forEach((wrapper) => {
        wrapper.classList.remove('active');
        wrapper.querySelector('label').classList.remove('rc-radio--active');
      });

      const selectedWrapper = radio.closest('.custom-widget-wrapper');
      selectedWrapper.classList.add('active');
      selectedWrapper.querySelector('label').classList.add('rc-radio--active');

      if (selectedWrapper.classList.contains('one-time-wrapper')) {
        cancelledSubscriptionDefaults.add(container);
        if (inputSellingPlan) inputSellingPlan.value = '';
        dispatchSellingPlanChange('onetime');
      } else {
        const sellingPlanId = getSelectedSubscriptionPlanId(container) || selectedSubscriptionFrequency?.value || '';
        if (inputSellingPlan) inputSellingPlan.value = sellingPlanId;
        dispatchSellingPlanChange('sub');
      }

      let price = 0;
      if (selectedWrapper.classList.contains('sub-wrapper')) {
        price = parseFloat(
          selectedWrapper.querySelector('.yk-radio__price').textContent.replace(' zł', '').replace(',', '.')
        );
      } else if (selectedWrapper.classList.contains('one-time-wrapper')) {
        price = parseFloat(
          selectedWrapper.querySelector('.yk-radio__price').textContent.replace(' zł', '').replace(',', '.')
        );
      }

      updateAddToCartButton(price, container);
    });
  });
}

function updateAddToCartButton(price, container = document) {
  const button_add_to_cart = container.querySelectorAll('.totalPriceOnButton');
  const quantityInput = container.querySelector('.quantity__input');
  button_add_to_cart.forEach(
    (el) => (el.textContent = `${String((price * quantityInput.value).toFixed(2)).replace('.', ',')} zł`)
  );
}

const FAST_BUY_SUB_WRAPPER_HEIGHT = 142;

const getProductData = (productData, container = document) => {
  if (productData) return productData;

  const rawProductInfo =
    container.querySelector('.product__data-json') ||
    container.closest?.('.shopify-section')?.querySelector('.product__data-json');
  return rawProductInfo ? JSON.parse(rawProductInfo.textContent) : null;
};

const getRecurringSellingPlans = (sellingPlanGroup) =>
  Array.isArray(sellingPlanGroup?.selling_plans)
    ? sellingPlanGroup.selling_plans.filter((plan) => plan.recurring_deliveries)
    : [];

const getPreferredSellingPlanGroup = (sellingPlanGroups) => {
  if (!Array.isArray(sellingPlanGroups)) return null;

  return sellingPlanGroups.reduce((bestGroup, currentGroup) => {
    const getGroupDiscount = (group) =>
      getRecurringSellingPlans(group).reduce(
        (maxDiscount, plan) => Math.max(maxDiscount, Number(plan?.price_adjustments?.[0]?.value || 0)),
        0
      );

    if (!bestGroup) return currentGroup;

    return getGroupDiscount(currentGroup) > getGroupDiscount(bestGroup) ? currentGroup : bestGroup;
  }, null);
};

const getDefaultRecurringSellingPlan = (sellingPlans) => sellingPlans[1] || sellingPlans[0] || null;

const getWidgetSellingPlanGroup = (sellingPlanGroups, container = document) => {
  if (!Array.isArray(sellingPlanGroups)) return null;

  const subWrapper = container.querySelector('#yk-subscription-wrapper');
  const sellingPlanGroupId = subWrapper?.dataset.sellingPlanGroupId;

  if (sellingPlanGroupId) {
    const matchedGroup = sellingPlanGroups.find((group) => String(group.id) === sellingPlanGroupId);
    if (matchedGroup) return matchedGroup;
  }

  return getPreferredSellingPlanGroup(sellingPlanGroups);
};

const getSubscriptionDiscountMultiplier = (container = document) => {
  const subWrapper = container.querySelector('#yk-subscription-wrapper');
  const discountPercent = Number(subWrapper?.dataset.subscriptionDiscountPercent || 15);
  return (100 - discountPercent) / 100;
};

const getSelectedSubscriptionPlanId = (container = document) => {
  const selectedSubscriptionFrequency = container.querySelector('.yk-custom-select');
  const subWrapper = container.querySelector('#yk-subscription-wrapper');

  return selectedSubscriptionFrequency?.value || subWrapper?.dataset.defaultSellingPlanId || '';
};

const getSubscriptionAllocation = (variant, container = document) => {
  if (!variant || !Array.isArray(variant.selling_plan_allocations)) return null;

  const selectedPlanId = getSelectedSubscriptionPlanId(container);
  const subWrapper = container.querySelector('#yk-subscription-wrapper');
  const sellingPlanGroupId = subWrapper?.dataset.sellingPlanGroupId;

  if (selectedPlanId) {
    const matchedByPlanId = variant.selling_plan_allocations.find(
      (allocation) => String(allocation?.selling_plan?.id ?? allocation?.selling_plan_id) === String(selectedPlanId)
    );
    if (matchedByPlanId) return matchedByPlanId;
  }

  if (sellingPlanGroupId) {
    const matchedByGroupId = variant.selling_plan_allocations.find(
      (allocation) =>
        String(allocation?.selling_plan_group_id) === String(sellingPlanGroupId) &&
        allocation?.selling_plan?.recurring_deliveries
    );
    if (matchedByGroupId) return matchedByGroupId;
  }

  return (
    variant.selling_plan_allocations.find((allocation) => allocation?.selling_plan?.recurring_deliveries) || null
  );
};

const getVariantSubscriptionPrice = (variant, container = document) => {
  const allocation = getSubscriptionAllocation(variant, container);
  if (allocation?.per_delivery_price != null) return allocation.per_delivery_price / 100;
  if (allocation?.price != null) return allocation.price / 100;

  const basePrice = Number(variant?.price || 0) / 100;
  return basePrice * getSubscriptionDiscountMultiplier(container);
};

window.getVariantSubscriptionPrice = getVariantSubscriptionPrice;

const handleSubscriptionDropdown = (productData, container = document) => {
  const customDropdownWrapper = container.querySelector('.yk-custom-dropdown-wrapper');
  const selectButton = container.querySelector('.yk-custom-select');
  const dropdownMenu = container.querySelector('.yk-custom-dropdown');
  const inputSellingPlan = container.querySelector('input[name="selling_plan"]');
  const product = getProductData(productData, container);

  if (!customDropdownWrapper || !selectButton || !dropdownMenu) return;

  const widgetSellingPlanGroup = getWidgetSellingPlanGroup(product?.selling_plan_groups, container);
  const sellingPlans = getRecurringSellingPlans(widgetSellingPlanGroup).slice(0, 3);

  if (sellingPlans.length <= 1) return;

  function getMonthWordFromPlanName(planName) {
    const match = planName.match(/Dostawa co (\d+)/);

    if (!match) return planName;

    const n = parseInt(match[1], 10);

    let suffix = 'miesięcy';

    if (n === 1) suffix = 'miesiąc';
    else if ([2, 3, 4].includes(n)) suffix = 'miesiące';

    return `Dostawa co ${n} ${suffix}`;
  }

  const defaultSellingPlan = getDefaultRecurringSellingPlan(sellingPlans);

  if (!defaultSellingPlan) return;

  selectButton.innerText = getMonthWordFromPlanName(defaultSellingPlan.name);

  selectButton.value = defaultSellingPlan.id;
  if (inputSellingPlan) inputSellingPlan.value = defaultSellingPlan.id;

  const handleChooseSubscriptionFrequency = (event, plan) => {
    event.preventDefault();
    cancelledSubscriptionDefaults.add(container);
    selectButton.innerText = getMonthWordFromPlanName(plan.name);
    selectButton.value = plan.id;
    if (inputSellingPlan) inputSellingPlan.value = plan.id;
    customDropdownWrapper.classList.remove('active');
    initializeWidgetPriceFromVisibleVariant(container, product);
    const isSubscription = container.querySelector('.sub-wrapper')?.classList.contains('active');
    document.dispatchEvent(new CustomEvent(
      container.closest?.('#fast-buy-drawer') ? 'quick-buy:selling-plan-change' : 'onSellingPlanChange',
      { detail: { planType: isSubscription ? 'sub' : 'onetime', container, sellingPlanId: plan.id } }
    ));
  };

  dropdownMenu.innerHTML = '';
  sellingPlans.forEach((plan) => {
    if (!plan.recurring_deliveries) return;

    const optionButton = document.createElement('button');
    optionButton.type = 'button';
    optionButton.classList.add('custom-option');

    optionButton.innerText = getMonthWordFromPlanName(plan.name);

    optionButton.setAttribute('value', plan.id);
    optionButton.setAttribute('data-name', plan.name);

    optionButton.addEventListener('click', (event) => handleChooseSubscriptionFrequency(event, plan));

    dropdownMenu.appendChild(optionButton);
  });

  selectButton.addEventListener('click', (event) => {
    event.preventDefault();
    customDropdownWrapper.classList.toggle('active');
  });

  window.addEventListener('click', (event) => {
    if (!customDropdownWrapper.contains(event.target)) {
      customDropdownWrapper.classList.remove('active');
    }
  });
};

const handleAnimatePurchaseOptions = (options = {}) => {
  const { source, container = document } = options;
  const subWrapper = container.querySelector('.sub-wrapper');
  const oneTimeWrapper = container.querySelector('.one-time-wrapper');
  const radioButtons = container.querySelectorAll('input:is([name="purchaseOption"], [name="quick-buy-purchaseOption"])');
  const isNode = (el) => !!(el && el.nodeType === 1);
  let initial = true;
  const updateInitialInputsHeight = () => {
    if (initial && subWrapper) {
      subWrapper.style.height = subWrapper.scrollHeight === 0 ? 'auto' : subWrapper.scrollHeight + 2 + 'px';
      subWrapper.style.overflow = 'visible';
      return (initial = false);
    }
  };

  if (isNode(subWrapper)) {
    const observer = new MutationObserver(updateInitialInputsHeight);
    observer.observe(subWrapper, { childList: true, subtree: true });
  }

  window.addEventListener('resize', updateInitialInputsHeight);

  const collapseHandler = (element) => {
    element.style.height = element.querySelector('label').scrollHeight + 2 + 'px';
    element.classList.remove('active');
    element.style.overflow = 'hidden';
  };

  const expandHandler = (element) => {
    if (source === 'fast-buy') {
      element.style.setProperty('height', `${FAST_BUY_SUB_WRAPPER_HEIGHT}px`, 'important');
    } else {
      element.style.height = element.scrollHeight + 2 + 'px';
    }
    element.classList.add('active');
    setTimeout(() => (element.style.overflow = 'visible'), 350);
  };

  const animate = (activeOption) => {
    if (activeOption === 'onetime') {
      collapseHandler(subWrapper);
      expandHandler(oneTimeWrapper);
    } else {
      collapseHandler(oneTimeWrapper);
      expandHandler(subWrapper);
    }
  };

  radioButtons.forEach((radio) => {
    radio.addEventListener('change', function () {
      animate(this.value);
    });
  });
};

const handleInjectSubscriptionBars = (container = document) => {
  const widgetDropdown = container.querySelector('.widget-text-blocks-wrapper');
  const subscriptionBenefits = container.querySelectorAll(
    '.product__subscription:not(.product__subscription--single-purchase)'
  );

  subscriptionBenefits.forEach((bar) => {
    widgetDropdown.appendChild(bar);
  });
};

const createModal = (buttonId, modalId, container = document) => {
  const btn = container.querySelector(`#${buttonId}`);
  const modal =
    container.querySelector(`#${modalId}`) ||
    (container.closest?.('#fast-buy-drawer')
      ? document.querySelector(`#yk-quick-buy-how-subs-works-modal #${modalId}`)
      : null);
  const closeBtn = modal?.querySelector('.modal-close');

  if (btn && modal && closeBtn) {
    btn.addEventListener('click', () => {
      modal.classList.add('active');
    });

    closeBtn.addEventListener('click', () => {
      modal.classList.remove('active');
    });

    window.addEventListener('click', (event) => {
      if (event.target === modal) {
        modal.classList.remove('active');
      }
    });
  }
};

const quickModalCountCompareAtPrice = (compareOnetime, container = document) => {
  const parsedComparedPrice = parseFloat(compareOnetime.replace(/[^\d,]/g, '').replace(',', '.'));
  const subscriptionComparedPrice =
    (parsedComparedPrice * getSubscriptionDiscountMultiplier(container)).toFixed(2).replace('.', ',') + ' ZŁ';

  return subscriptionComparedPrice;
};

const handleCompareAtPrice = (container = document) => {
  const widget = container.querySelector('#yk-subscription-widget');
  const variantDescritpion = container.querySelectorAll('.variant__description');
  const crossedOutPriceSub = container.querySelector('.sub-wrapper .crossed-out-price');
  const crossedOutPriceOnetime = container.querySelector('.one-time-wrapper .crossed-out-price');

  if (widget) {
    for (let i = 0; i < variantDescritpion.length; i++) {
      const description = variantDescritpion[i];
      const compareAtPrice = description.getAttribute('compareatprice');

      if (description.style.display === 'block' && compareAtPrice !== '') {
        crossedOutPriceOnetime.textContent = compareAtPrice;
        crossedOutPriceOnetime.style.display = 'block';

        crossedOutPriceSub.textContent = quickModalCountCompareAtPrice(compareAtPrice, container);
        crossedOutPriceSub.style.display = 'block';
        break;
      }
    }
  }
};

function initializeWidgetPriceFromVisibleVariant(container = document, productData = null) {
  const widget = container.querySelector('#yk-subscription-widget');
  if (!widget) return;

  const product = getProductData(productData, container);
  const description = Array.from(container.querySelectorAll('.variant__description')).find(
    (element) => element.style.display === 'block'
  );
  const variantId = Number(
    container.querySelector('input[name="id"]')?.value || description?.getAttribute('data-variant-id')
  );
  const variant = product?.variants?.find((entry) => Number(entry.id) === variantId);
  if (!variant) return;

  const quantity = Number(container.querySelector('.quantity__input')?.value || 1);
  const price = variant.price / 100;
  const subscriptionPrice = getVariantSubscriptionPrice(variant, container);
  const subPriceEl = widget.querySelector('.sub-wrapper .yk-radio__price');
  const onetimePriceEl = widget.querySelector('.one-time-wrapper .yk-radio__price');
  if (subPriceEl) subPriceEl.textContent = subscriptionPrice.toFixed(2).replace('.', ',') + ' ZŁ';
  if (onetimePriceEl) onetimePriceEl.textContent = price.toFixed(2).replace('.', ',') + ' ZŁ';

  const isSubscription = container.querySelector('#yk-subscription-wrapper')?.classList.contains('active');
  const total = ((isSubscription ? subscriptionPrice : price) * quantity).toFixed(2).replace('.', ',') + ' ZŁ';
  container.querySelectorAll('.totalPriceOnButton').forEach((button) => { button.textContent = total; });

  const compareAt = description?.getAttribute('compareatprice') || '';
  const crossedOutPriceSub = widget.querySelector('.sub-wrapper .crossed-out-price');
  const crossedOutPriceOnetime = widget.querySelector('.one-time-wrapper .crossed-out-price');
  if (crossedOutPriceOnetime) {
    crossedOutPriceOnetime.textContent = compareAt;
    crossedOutPriceOnetime.style.display = compareAt ? 'block' : 'none';
  }
  if (crossedOutPriceSub) {
    crossedOutPriceSub.textContent = compareAt ? quickModalCountCompareAtPrice(compareAt, container) : '';
    crossedOutPriceSub.style.display = compareAt ? 'block' : 'none';
  }
}

const cancelledSubscriptionDefaults = new WeakSet();

function handleSetJuoDefaultSellingPlan(productData, container = document) {
  const product = getProductData(productData, container);
  const subWrapper = container.querySelector('#yk-subscription-wrapper');
  const preferredSellingPlanGroup = getWidgetSellingPlanGroup(product?.selling_plan_groups, container);
  const defaultSellingPlan =
    subWrapper?.dataset.defaultSellingPlanId || getDefaultRecurringSellingPlan(getRecurringSellingPlans(preferredSellingPlanGroup))?.id;
  const defaultSellingPlanId = defaultSellingPlan ? String(defaultSellingPlan) : '';

  if (!defaultSellingPlanId) return Promise.resolve();

  return new Promise((resolve) => {
    let observer;
    let checkInterval;
    let input;
    const finish = (ready) => {
      observer?.disconnect();
      clearInterval(checkInterval);
      clearTimeout(deadline);
      resolve(ready);
    };
    // Bound the entire wait, including the time before Juo inserts its input.
    const deadline = setTimeout(() => finish(false), 5000);
    const forceSetValue = () => {
      if (!input || cancelledSubscriptionDefaults.has(container)) return;
      if (input.value !== defaultSellingPlanId) input.value = defaultSellingPlanId;
    };
    const startWatchingInput = (foundInput) => {
      input = foundInput;
      observer?.disconnect();
      forceSetValue();
      checkInterval = setInterval(() => {
        if (!document.body.contains(input)) {
          finish(false);
        } else if (cancelledSubscriptionDefaults.has(container) || input.value === defaultSellingPlanId) {
          finish(true);
        } else {
          forceSetValue();
        }
      }, 300);
    };

    const existingInput = container.querySelector('input[name="selling_plan"]');
    if (existingInput) {
      startWatchingInput(existingInput);
      return;
    }
    observer = new MutationObserver(() => {
      const foundInput = container.querySelector('input[name="selling_plan"]');
      if (foundInput) startWatchingInput(foundInput);
    });
    observer.observe(container === document ? document.body : container, { childList: true, subtree: true });
  });
}

async function initializeSubscriptionWidget(product, options = {}) {
  const { source } = options;
  const container = options.container || document.querySelector('.product-information-section') || document;
  const hasSellingPlans = Array.isArray(product?.selling_plan_groups) && product.selling_plan_groups.length > 0;
  const skipSellingPlanForFastBuy = source === 'fast-buy' && !hasSellingPlans;

  if (skipSellingPlanForFastBuy) cancelledSubscriptionDefaults.add(container);
  else cancelledSubscriptionDefaults.delete(container);

  if (source === 'fast-buy') {
    const addToSubTrigger = container.querySelector('#widget-add-to-sub-trigger');
    if (addToSubTrigger) addToSubTrigger.remove();
  }

  const radioButtons = container.querySelectorAll('input:is([name="purchaseOption"], [name="quick-buy-purchaseOption"])');
  radioButtons.forEach((radio) => {
    radio.disabled = true;
  });
  const customSelect = container.querySelector('.yk-custom-select');
  if (customSelect) customSelect.disabled = true;

  const sellingPlanInput = container.querySelector('input[name="selling_plan"]');

  let ready;
  try {
    if (!skipSellingPlanForFastBuy) {
      ready = await handleSetJuoDefaultSellingPlan(product, container);
    } else if (sellingPlanInput) {
      sellingPlanInput.value = '';
    }
  } finally {
    radioButtons.forEach((radio) => { radio.disabled = false; });
    if (customSelect) customSelect.disabled = false;
  }
  if (ready === false) return false;

  toggleActivePurchaseOption(container);
  handleSubscriptionDropdown(product, container);
  handleAnimatePurchaseOptions({ source, container });

  const firstInput = container.querySelector('.sub-wrapper input:is([name="purchaseOption"], [name="quick-buy-purchaseOption"])');
  if (firstInput) {
    firstInput.checked = true;
    firstInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  initializeWidgetPriceFromVisibleVariant(container, product);
  handleInjectSubscriptionBars(container);
  handleCompareAtPrice(container);
  if (source === 'fast-buy') {
    const applyFastBuyLayout = () => {
      const subWrapperEl = container.querySelector('#yk-subscription-wrapper');
      if (!subWrapperEl) return;
      subWrapperEl.style.setProperty('height', `${FAST_BUY_SUB_WRAPPER_HEIGHT}px`, 'important');
      // subWrapperEl.style.setProperty('overflow', 'hidden', 'important');
    };

    applyFastBuyLayout();
    requestAnimationFrame(applyFastBuyLayout);
    setTimeout(applyFastBuyLayout, 0);
    setTimeout(applyFastBuyLayout, 150);
  }
  const modalRoot = source === 'fast-buy' ? container : document;
  createModal('modal-blik-trigger', 'modal-blik-content', modalRoot);
  createModal('yk-modal-trigger', 'modal-recharge-widget', modalRoot);
  return true;
}

document.addEventListener('DOMContentLoaded', () => {
  initializeSubscriptionWidget(null, { source: 'product-page' }).catch((error) => {
    console.error('Błąd inicjalizacji widgetu subskrypcji:', error);
  });
});
